import React from "react";
import StockItemRow, { ItemRowValue, Option } from "../ItemRow";
import "./styles.css";

export const EMPTY_ROW = (stateId: string, list1Id: string, list2Id: string, list3Id: string): ItemRowValue => ({
  name: "",
  stateId: stateId,
  list1Id: list1Id,
  list2Id: list2Id,
  list3Id: list3Id,
  quantity: 0,
});

export type ItemListEditProps = {
  header?: string;
  items: ItemRowValue[];
  list1Options?: Option[];
  list2Options?: Option[];
  list3Options?: Option[];
  itemStateOptions?: Option[];
  onAddCollection?: (label: string) => void;
  onAddGender?: (label: string) => void;
  onAddSize?: (label: string) => void;
  displayAddListItem?: boolean;
  onChange?: (index: number, items: ItemRowValue | null) => void;
  onPrintCode?: (index: number) => void;
  printCode?: boolean;
  readonly?: boolean;
  addRowDisable?: boolean;
};

function ItemListEdit({
  header = "",
  list1Options,
  list2Options,
  list3Options,
  itemStateOptions,
  onAddCollection,
  onAddGender,
  onAddSize,
  displayAddListItem = false,
  items,
  onChange,
  onPrintCode,
  readonly = false,
  printCode = false,
  addRowDisable = false
}: ItemListEditProps) {
  const updateRow = (index: number, next: ItemRowValue) => {
    onChange && onChange(index, next);
  };

  const removeRow = (index: number) => {
    onChange && onChange(index, null);
  };

  const handlePrintCode = (index: number) => {
    onPrintCode && onPrintCode(index);
  };

  const addRow = () => {
    onChange && onChange(-1, EMPTY_ROW(itemStateOptions[0].value, list1Options[0].value, list2Options[0].value, list3Options[0].value));
  };

  const isEmpty = !items || items.length === 0;

  return (
    <div style={{ display: "grid", gap: 12 }}>
      {(header || true) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          {header && <h4 style={{ margin: 0, marginBottom: 3, color: "#013868" }}>{header}</h4>}

          {!readonly && !addRowDisable && (
            <button
              type="button"
              className="stock-item-add"
              onClick={addRow}
              aria-label="Přidat položku"
              title="Přidat položku"
            >
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path
                  d="M12 5v14M5 12h14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          )}
        </div>
      )}

      {isEmpty ? (
        <div className="stock-empty">
          Žádné položky
        </div>
      ) : (
        items.map((item, index) => (
          <StockItemRow
            key={index}
            value={item}
            list1Options={list1Options}
            list2Options={list2Options}
            list3Options={list3Options}
            itemStateOptions={itemStateOptions}
            onAddCollection={onAddCollection}
            onAddGender={onAddGender}
            onAddSize={onAddSize}
            displayAddListItem={displayAddListItem}
            amountMin={1}
            onChange={(next) => updateRow(index, next)}
            onRemove={() => removeRow(index)}
            onPrintCode={() => handlePrintCode(index)}
            handlePrintCode={printCode}
            readOnly={readonly}
          />
        ))
      )}
    </div>
  );
}

export default ItemListEdit;